import { ApolloClient, ApolloLink, ApolloProvider, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { createUploadLink } from 'apollo-upload-client';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import store from '../store';
import TelemetryProvider from './TelemetryProvider';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { APTEAN_IAM_AUTHORITY, APTEAN_IAM_CLIENT_ID, APTEAN_IAM_REALM } from '../util/Constants';
import Keycloak from 'keycloak-js';

const uploadLink = createUploadLink({
  uri: `${process.env.REACT_APP_EZPAY_API_ENDPOINT}`,
  credentials: 'same-origin',
}) as unknown;

export const gqlClient = new ApolloClient({
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    },
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
  },
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) =>
          console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`),
        );
      }
      if (networkError) console.log(`[Network error]: ${networkError}`);
    }),
    uploadLink as ApolloLink,
  ]),
  cache: new InMemoryCache(),
});
const AppProvider: React.FC = ({ children }) => {
  const keycloak = new Keycloak({
    url: APTEAN_IAM_AUTHORITY,
    realm: APTEAN_IAM_REALM,
    clientId: APTEAN_IAM_CLIENT_ID,
  });
  return (
    //TODO Abbey removed AzureAD provider from this so we can switch over to the aptean
    // left here for now for debug purposes.
    //<AzureAD provider={authProvider} forceLogin={true}>
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{
        onLoad: 'login-required',
        redirectUri: window.location.origin,
      }}
    >
      <ApolloProvider client={gqlClient}>
        <Provider store={store}>
          <Router>
            <TelemetryProvider cssClassName={''}>{children}</TelemetryProvider>
          </Router>
        </Provider>
      </ApolloProvider>
    </ReactKeycloakProvider>
    //</AzureAD>
  );
};

export default AppProvider;
